import React from "react";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import LoadingData from "../../TESTPage/LoadingData";
import UserSelector from "../../../components/users/UsersSelector";

/**
 * การ์ดแสดง/แก้ไขลำดับผู้อนุมัติ (approveUserFlow)
 * เดิมมี JSX เกือบเหมือนกัน 2 จุด:
 * - EvaluateForm (Insert): editable เสมอ, ไม่มี branch read-only
 * - EditEvaluateForm (Edit): editable ตามเงื่อนไข status/CheckSubAdmin, มี branch read-only
 *
 * props:
 * - flowLoading, approveUserFlow, editable
 * - onChangeUser(index, value), onRemove(index), onAdd(), onSave(), onReset()
 * - loadingProps: ส่งต่อให้ <LoadingData /> (Insert ใช้ {width:100,height:60}, Edit ไม่ส่ง)
 * - cardBodyStyle: style ของ CardBody (Insert ใช้ {minHeight:"120px"}, Edit ไม่ใส่)
 */
function ApproveFlowCard({
  flowLoading,
  approveUserFlow,
  editable,
  onChangeUser,
  onRemove,
  onAdd,
  onSave,
  onReset,
  loadingProps = {},
  cardBodyStyle,
}) {
  const renderEditableRow = (x, i, a) => {
    const disabled = x.assessor;
    return (
      <Row key={i}>
        <Col md={10}>
          <Row>
            <Col className="text-end" xs={4} md={2} lg={3}>
              <strong> ผู้ประเมิน :</strong>
            </Col>
            <Col xs={8} md={10} lg={9}>
              <Row>
                <Col md={10}>
                  <UserSelector
                    disabled={disabled}
                    className={"mb-2"}
                    value={{ value: x, label: x.approve_user }}
                    onChange={value => onChangeUser(i, value)}
                  />
                </Col>
                <Col md={2}>
                  {!disabled && (
                    <Button color="danger" onClick={() => onRemove(i)}>
                      <i className="fa-solid fa-xmark" />
                    </Button>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
          {x.approve_user_position_name && (
            <Row>
              <Col className="text-end" xs={4} md={2} lg={3}>
                <strong> ตำแหน่ง :</strong>
              </Col>
              <Col xs={8} md={10} lg={9}>
                <strong>{x.approve_user_position_name}</strong>
              </Col>
            </Row>
          )}
          {x.cont_to && (
            <Row>
              <Col className="text-end" xs={4} md={2} lg={3}>
                <strong> สังกัด :</strong>
              </Col>
              <Col xs={8} md={10} lg={9}>
                <strong>{x.cont_to}</strong>
              </Col>
            </Row>
          )}
        </Col>
        <Row className="text-center mt-2">
          {!(i === a.length - 1) ? (
            <Col md={12}>
              <i className="fa-solid fa-caret-down fa-2x text-center m-2" />
            </Col>
          ) : (
            <Row>
              <Col md={12} className="d-flex justify-content-center gap-2 mt-2">
                <Button color="primary" className="w-25" onClick={onAdd}>
                  <i className="fa-solid fa-plus" /> เพิ่ม
                </Button>
                <Button color="success" className="w-25" onClick={onSave}>
                  <i className="fa-solid fa-save" /> บันทึก
                </Button>
                <Button color="secondary" className="w-25" onClick={onReset}>
                  <i className="fa-solid fa-history" /> รีเซ็ต
                </Button>
              </Col>
              <Col md={12} className="text-center mt-3">
                <span className="text-danger">
                  ***หากลำดับขั้นการประเมินของท่านไม่ถูกต้อง ท่านสามารถดำเนินการแก้ไขเองได้ หรือติดต่อกลุ่ม IT
                </span>
              </Col>
              <Col md={12} className="text-center">
                <span className="text-danger">
                  แต่หากลำดับขั้นการประเมินของท่านถูกต้องแล้ว ให้ดำเนินการกรอกข้อมูลตัวชี้วัดผลงานได้ทันที
                </span>
              </Col>
            </Row>
          )}
        </Row>
      </Row>
    );
  };

  const renderReadOnlyRow = (x, i) => (
    <Row key={i}>
      <Col md={10}>
        <Row>
          <Col className="text-end" xs={4} md={2} lg={3}>
            <strong> ผู้ประเมิน :</strong>
          </Col>
          <Col xs={8} md={10} lg={9}>
            <Row>
              <Col>
                <strong>{x.approve_user}</strong>
              </Col>
            </Row>
          </Col>
        </Row>
        {x.approve_user_position_name && (
          <Row>
            <Col className="text-end" xs={4} md={2} lg={3}>
              <strong> ตำแหน่ง :</strong>
            </Col>
            <Col xs={8} md={10} lg={9}>
              <strong>{x.approve_user_position_name}</strong>
            </Col>
          </Row>
        )}
        {x.cont_to && (
          <Row>
            <Col className="text-end" xs={4} md={2} lg={3}>
              <strong> สังกัด :</strong>
            </Col>
            <Col xs={8} md={10} lg={9}>
              <strong>{x.cont_to}</strong>
            </Col>
          </Row>
        )}
      </Col>
      <Row className="text-center mt-2">
        {!(i === approveUserFlow.length - 1) ? (
          <Col md={12}>
            <i className="fa-solid fa-caret-down fa-2x text-center m-2" />
          </Col>
        ) : null}
      </Row>
    </Row>
  );

  return (
    <Card>
      <CardBody style={cardBodyStyle}>
        {flowLoading ? (
          <LoadingData {...loadingProps} />
        ) : editable ? (
          approveUserFlow?.length === 0 ? (
            <Row>
              <Col md={12}>
                <strong>รอสักครู่</strong>
              </Col>
            </Row>
          ) : (
            approveUserFlow?.map((x, i, a) => renderEditableRow(x, i, a))
          )
        ) : (
          approveUserFlow?.map((x, i) => renderReadOnlyRow(x, i))
        )}
      </CardBody>
    </Card>
  );
}

export default ApproveFlowCard;
